import React, { Component } from 'react';

class Loader extends Component {

  render() {

    const { minHeight, size } = this.props;

    return (
      <div className="col">
        <div className="loader" style={{ 'minHeight': minHeight }}>
          <div className={`circle-scale ${size}`}></div>
        </div>
      </div>
    );
  }
}

export default Loader;
